module.exports = __webpack_public_path__ + "img/image24.f8cdfb2f.jpg";